import fs from 'node:fs'
import path from 'node:path'
import { FORMAT_TIMEOUT_MS } from '@cli-constants/timeouts.js'
import { execFileAsync } from './exec-file-async.js'
import { getExistingTrackedFilePaths } from './get-existing-tracked-file-paths.js'

export async function runOxfmtCheckWrite(cwd: string): Promise<boolean> {
  const oxfmtBin = path.join(cwd, 'node_modules', '.bin', 'oxfmt')
  if (!fs.existsSync(oxfmtBin)) {
    return false
  }

  const filePaths = getExistingTrackedFilePaths(cwd)
  if (filePaths.length === 0) {
    return true
  }

  const chunkSize = 80
  for (let index = 0; index < filePaths.length; index += chunkSize) {
    const chunk = filePaths.slice(index, index + chunkSize)
    await execFileAsync(oxfmtBin, ['--no-error-on-unmatched-pattern', ...chunk], {
      cwd,
      timeout: FORMAT_TIMEOUT_MS
    })
  }

  return true
}
